import { render, staticRenderFns } from "./summaryYoutube.vue?vue&type=template&id=6331d33d&scoped=true&"
import script from "./summaryYoutube.vue?vue&type=script&lang=js&"
export * from "./summaryYoutube.vue?vue&type=script&lang=js&"
import style0 from "./summaryYoutube.vue?vue&type=style&index=0&id=6331d33d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331d33d",
  null
  
)

export default component.exports